// Whether tapping a dish on the till asks before it goes on the order (Oct 2026).
//
// Tap to add is the rule: a dish goes straight on, and the pencil adds sauces or notes after.
// A dish asks first when it's "Always ask", or when it has a choice that has to be made and
// changes the price: a pint or a half, a 125 or a 250, oat milk. Taking the default there
// charges the wrong amount without anyone deciding to. A free choice with a default (how
// it's cooked) still goes straight on at its default.
//
// Sizes are such a choice: a "Size" group, or the sizes set up on the item ("Add a size"),
// which the sheet shows as one (lib/sizeChoice, Nov 2026; they had a dialog of their own,
// and a long press opened a sheet without them). One size only is no choice: the till puts
// it straight on. A meal asks too: nobody can sell a kids meal without saying which main.

const pence = (v) => Math.round((Number(v) || 0) * 100);

export function asksOnTap(item) {
  if (!item) return false;
  if (item.always_ask) return true;
  if (item.has_sizes && (item.size_options || []).length) return (item.size_options || []).length > 1;
  if ((item.meal_groups || []).length) return true;
  return (item.modifier_groups || []).some((g) => g.rule === 'one'
    && (g.options || []).length > 1
    && new Set(g.options.map((o) => pence(o.price))).size > 1);
}
